/* eslint-disable @typescript-eslint/no-explicit-any */
import { useStore } from '@/containers'
import type { GiftItems, OtherOffers } from '@/types'
import { getTranslate } from '@/utils/api-interceptors'
import Link from 'next/link'
import { useCallback, type Dispatch, type SetStateAction } from 'react'
import { v4 as uuidv4 } from 'uuid'
import { FormRadioButtonCircle, FormRadioButtonItems } from '../Form'

interface InformationType {
  setListGift: Dispatch<SetStateAction<GiftItems[] | undefined>>
  listGift: GiftItems[] | undefined
  setListOffer: Dispatch<SetStateAction<OtherOffers[] | undefined>>
  listOffer: OtherOffers[] | undefined
  login?: boolean
}
export const Gift = ({ listGift, listOffer, setListGift }: InformationType) => {
  const { selectedLang } = useStore()
  const currency = (lang: string) => {
    switch (lang) {
      case 'vi':
        return 'VND'
      case 'en':
        return 'USD'
      default:
        return 'VND'
    }
  }

  const handleOptionChange = useCallback(
    (e: GiftItems, value: boolean) => {
      if (setListGift && listGift) {
        const updatedGifts = listGift.map(gift =>
          gift._id === e._id ? { ...gift, checked: value } : gift
        )
        setListGift(updatedGifts)
      }
    },
    [listGift, setListGift]
  )

  return (
    <>
      <div className='bg-white p-3 rounded'>
        <h2 className='text-sm text-left text-dark-900 font-bold mb-2'>
          Khuyến mãi kèm theo
        </h2>
        <div className='main-description break-words'>
          {listGift &&
            listGift?.map((e: GiftItems, i: number) => (
              <div
                className='form-check-default box-checkbox mt-1.5 flex'
                key={e._id}
              >
                <span className='mr-2 flex h-[20px] w-[20px] flex-[0_0_20px] items-center justify-center rounded-full bg-primary-base text-xs text-white font-medium leading-3'>
                  {i + 1}
                </span>
                <div className='gap-x-2 w-full'>
                  {e?.optionBuy ? (
                    <span className='text-sm text-dark-900'>
                      Chọn 1 trong các khuyến mãi{' '}
                    </span>
                  ) : (
                    <>
                      <span className='text-sm text-dark-900'>Tặng </span>
                      <span className={`text-sm text-dark-900`}>
                        {getTranslate(e?.name)}
                      </span>
                      {e.viewMoreLink && (
                        <Link
                          href={e.viewMoreLink || '/'}
                          target='_blank'
                          className='text-blue ml-[5px] text-sm italic'
                        >
                          (Chi tiết)
                        </Link>
                      )}
                    </>
                  )}
                  {e?.optionBuy && (
                    <>
                      <FormRadioButtonItems
                        key={e._id}
                        className='mt-2 flex-col'
                      >
                        {[
                          {
                            _id: uuidv4(),
                            label: `Giảm ${e?.price
                              .toLocaleString(selectedLang as string, {
                                style: 'currency',
                                currency: currency(selectedLang as string),
                              })
                              .replace(/\s₫/g, 'đ')}`,
                            value: e._id + '_false',
                          },
                          {
                            _id: uuidv4(),
                            label: (
                              <>
                                Tặng <strong>{getTranslate(e?.name)}</strong>
                                {e.viewMoreLink && (
                                  <Link
                                    href={e.viewMoreLink || '/'}
                                    target='_blank'
                                    className='ml-[5px] text-sm italic text-primary-base'
                                  >
                                    (Chi tiết)
                                  </Link>
                                )}
                              </>
                            ),
                            value: e._id + '_true',
                          },
                        ].map((f: any, i) => (
                          <FormRadioButtonCircle
                            key={`optionBuy-${e._id}-${i}`}
                            inputName={`optionBuy-${e._id}`}
                            value={f.value}
                            labelClass='!normal-case cursor-pointer text-fieldInput'
                            checked={
                              e.checked?.toString() === f.value.split('_')[1]
                            }
                            onChange={event =>
                              handleOptionChange(
                                e,
                                event.target.value.split('_')[1] === 'true'
                              )
                            }
                            wrapperClass='!border-none !p-0 !m-0'
                            wrapperLabelClassName={'!mt-[0]'}
                          >
                            {f.label}
                          </FormRadioButtonCircle>
                        ))}
                      </FormRadioButtonItems>
                    </>
                  )}
                </div>
              </div>
            ))}
          {listOffer &&
            listOffer.length > 0 &&
            listOffer?.map((e: OtherOffers, i: number) => (
              <div
                className='form-check-default flex box-checkbox mt-2'
                key={i}
              >
                <span className='mr-2 flex-[0_0_20px] flex h-[20px] w-[20px] items-center justify-center self-center rounded-full bg-primary-base text-xs font-medium text-white leading-3'>
                  {i + (listGift?.length || 0) + 1}
                </span>
                <div className='gap-x-2 w-full'>
                  <span className='text-sm text-dark-900'>
                    {getTranslate(e?.content?.name)}
                  </span>
                  {e.content?.viewMoreLink && (
                    <Link
                      href={e.content.viewMoreLink || '/'}
                      target='_blank'
                      className='ml-[5px] text-mainBody italic text-primary-base'
                    >
                      (Chi tiết)
                    </Link>
                  )}
                </div>
              </div>
            ))}
        </div>
      </div>
    </>
  )
}

export default Gift
